import {Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from '@angular/common';
import {parseAnyDate} from "@shared/helpers/date-time.helpers";

@Pipe({
  name: 'safeDate',
  pure: true
})
export class SafeDatePipe implements PipeTransform {
  constructor(
    private readonly date: DatePipe
  ) {
  }

  transform(value: string | number | Date | null | undefined, format?: string, timezone?: string, locale?: string): string {
    return this.date.transform(
      parseAnyDate(value), format, timezone, locale
    );
  }
}
